import { Divider } from '@zenterprise-inc/ui';

import IndisNPKILookupSection from '@/components/tax-refund/individual/SelectAuth/IndisNPKILookupSection';
import IndisSimpleAuthLookupSection from '@/components/tax-refund/individual/SelectAuth/IndisSimpleAuthLookupSection';

const IndisSelectAuthContent = () => {
  return (
    <>
      <IndisSimpleAuthLookupSection />
      <div className="pb-6" />
      <Divider.Section />
      <div className="pb-4" />
      <IndisNPKILookupSection />
    </>
  );
};

export default IndisSelectAuthContent;
